import { ConfidenceLevelProps } from 'vet-bones/design-system/components';

import { CONFIDENCE_LEVEL_BY_SCORE } from 'src/constants/voicebox';

export const getConfidenceLevel = (
  score: number | undefined
): ConfidenceLevelProps['level'] =>
  CONFIDENCE_LEVEL_BY_SCORE[score || 0] || 'none';
